import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import moment from "moment";
import Service from "../../services/messages";
import UserService from "../../services/users";
export default function MessageEdit(props) {



  useEffect(() => {
    if (props.item && props.item._id) {
      const currentUser = UserService.currentUser();
      Service.markRead(props.item._id, currentUser._id).then(result => { });
    }
  }, [props.item]);

  let update = (ev) => {
    let item = Object.assign({}, props.item);

    if (ev.target.id === 'inactive') {
      item[ev.target.id] = ev.target.checked
    } else {
      item[ev.target.id] = ev.target.value;
    }

    props.handleUpdate(item);

  }
  function convertFileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  }
  const uploadImageToServer = async (attribute, event) => {
    try {
      let tmpItem = Object.assign({}, props.item);
      tmpItem.fileName = event.target.files[0].name;
      const uploadedImageBase64 = await convertFileToBase64(event.target.files[0]);

      tmpItem.fileContent = uploadedImageBase64;
      props.handleUpdate(tmpItem);
    } catch (ex) {
      console.log(ex);
    }

  }

  const downlodFile = (fileContent, fileName) => {
    const link = document.createElement('a');
    link.href = fileContent;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <div className="padding">
      {props.readOnly ?
        <>
          <h3>{props.item.title}<div className="label">{moment(props.item.lastModified).format('DD-MM-YYYY HH:mm')}</div></h3>
          <div style={{ whiteSpace: 'break-spaces' }}>{props.item.description}<br /><br /></div>
          {props.item.fileName && props.item.fileContent &&
            <>
              <div className="label"><br />Document</div><br />
              <div onClick={() => { downlodFile(props.item.fileContent, props.item.fileName) }} target="_blank" rel="noreferrer">{props.item.fileName}</div>
            </>}
        </>
        :
        <>
          <TextField
            margin="dense"
            id="title"
            label="Titel"
            type="text"
            value={props.item.title || ""}
            onChange={update}
            fullWidth
            readOnly={props.readOnly}
            required
          />
          <TextField
            multiline
            margin="dense"
            id="description"
            label="Bericht"
            type="text"
            value={props.item.description || ""}
            onChange={update}
            readOnly={props.readOnly}
            fullWidth
          />
          {props.item.fileName && props.item.fileContent &&
            <>
              <div className="label"><br />Document</div><br />
              <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => { downlodFile(props.item.fileContent, props.item.fileName) }} target="_blank" rel="noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6 }}>
                  <path d="M21.44 11.05l-8.49 8.49a5 5 0 0 1-7.07-7.07l9.19-9.19a3 3 0 0 1 4.24 4.24l-9.19 9.19a1 1 0 0 1-1.41-1.41l8.49-8.49" />
                </svg>
                {props.item.fileName}
              </div>
            </>}
          <br /><br />
          <div className="label">Upload (nieuw) document</div><br />
          <input type="file" onChange={(e) => { uploadImageToServer('iconWorkProcess', e) }} />
        </>}




    </div>
  );

}

